import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import useManagedField from './queries/useManagedField';
import baseStyles from '../../atoms/styles/baseStyles';
import fonts from '../../tokens/fonts';
import fontWeights from '../../tokens/fontWeights';
import colours from '../../tokens/colours';
import Feedback from '../Feedback';
const getStyles = createUseStyles({
    ...baseStyles,
    root: {
        position: 'relative',
        cursor: 'text',
        display: 'block',
        marginTop: 8,
    },
    label: {
        fontSize: '1.4rem',
        lineHeight: '2.4rem',
        height: '2.4rem',
        display: 'block',
        fontFamily: fonts.roboto,
        fontWeight: fontWeights.Regular,
        color: colours.sexternary,
        position: 'absolute',
        top: '2rem',
        left: '1.6rem',
        transition: 'all 0.2s linear',
    },
    labelActive: {
        fontSize: '1.2rem',
        top: '0.7rem',
        lineHeight: '1.6rem',
        height: '1.6rem',
    },
    labelDisabled: {
        color: colours.quinternary,
    },
    input: {
        fontSize: '1.4rem',
        lineHeight: '2rem',
        minHeight: '5.6rem',
        fontFamily: fonts.roboto,
        fontWeight: fontWeights.Regular,
        color: colours.primary,
        backgroundColor: colours.inputBackground,
        borderRadius: 4,
        border: `1px solid ${colours.inputBackground}`,
        padding: '2.2rem 1.5rem 0 1.5rem',
        width: '100%',
        boxSizing: 'border-box',
        transition: 'all 0.2s linear',
        '&:focus': {
            borderColor: colours.primary,
        },
        '&:disabled': {
            color: colours.quinternary,
        }
    },
    shortInput: {
        width: 64,
    },
    textarea: {
        width: 448,
        minHeight: 104,
    },
    error: {
        borderColor: '#E0032A',
        backgroundColor: 'rgba(224,3,42,0.051)',
        '&:focus': {
            borderColor: '#E0032A',
        },
    },
});
const TextInput = ({ className, labelText, onChange, defaultValue = '', variant = 'long', type, isError = false, disabled = false, ...rest }) => {
    const styles = getStyles();
    const [value, setValue] = useState(defaultValue);
    const [isFocus, setIsFocus] = useState(false);
    const onInputChange = (event) => {
        setValue(event.target.value);
        onChange(event);
    };
    const isLabelActive = isFocus || value !== '';
    const inputProps = {
        value: defaultValue,
        onChange: onInputChange,
        onFocus: () => setIsFocus(true),
        ...rest,
    };
    return (React.createElement("label", { className: classNames(styles.root, className) },
        React.createElement("span", { className: classNames(styles.label, { [styles.labelDisabled]: disabled }, { [styles.labelActive]: isLabelActive }) }, labelText),
        type === 'textarea' ?
            React.createElement("textarea", { className: classNames(styles.input, styles.textarea, { [styles.error]: isError }), ...inputProps }) :
            React.createElement("input", { className: classNames(styles.input, { [styles.shortInput]: variant === 'short' }, { [styles.error]: isError }), type: type, disabled: disabled, ...inputProps, onBlur: () => setIsFocus(false) })));
};
const ManagedTextInput = (props) => {
    const { defaultValue, disabled = false, onBlur } = props;
    const { meta: { error, isTouched, isValidating }, inputProps, setValue, } = useManagedField(props);
    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);
    const isError = !isValidating && isTouched && error;
    return (React.createElement(React.Fragment, null,
        isError && (React.createElement(Feedback, { type: "error" }, error)),
        React.createElement(TextInput, { ...inputProps, disabled: disabled, isError: isError, defaultValue: defaultValue, onBlur: onBlur })));
};
TextInput.Managed = ManagedTextInput;
export default TextInput;
//# sourceMappingURL=TextInput.js.map